import { useQuery } from "@tanstack/react-query";
import sessionsService from "@/features/sessions/services/sessionsService";
import type { AttendanceWithUser } from "@/features/sessions/types";
import DURATIONS from "@/shared/constants/durations";
import { sessionsKeys } from "./sessionsQueryKeys";

/**
 * Fetches all attendance records for a session with resolved user details
 *
 * @param sessionId - Session document ID to fetch attendance for
 */
export function useAttendanceForSession(sessionId: string) {
    return useQuery<AttendanceWithUser[], Error>({
        enabled: !!sessionId,
        gcTime: DURATIONS.FIVE_MINUTES,
        queryFn: () => sessionsService.getAttendanceForSession(sessionId),
        queryKey: sessionsKeys.attendance.session(sessionId),
        staleTime: DURATIONS.FIVE_MINUTES,
    });
}
